import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import TipsAndUpdatesRoundedIcon from "@mui/icons-material/TipsAndUpdatesRounded";

const insights = [
  {
    icon: <TrendingUpRoundedIcon color="success" />,
    text: "Eventos noturnos convertem 23% mais que diurnos",
    bg: "rgba(22,163,74,0.08)",
  },
  {
    icon: <WarningAmberRoundedIcon color="warning" />,
    text: "Queda de 12% na conversão de eventos corporativos",
    bg: "rgba(245,158,11,0.10)",
  },
  {
    icon: <TipsAndUpdatesRoundedIcon color="primary" />,
    text: "Eventos com preço abaixo de R$ 50 vendem 31% mais rápido",
    bg: "rgba(37,99,235,0.08)",
  },
];

export default function InsightsPanel() {
  return (
    <Stack spacing={2}>
      <Typography fontWeight={950}>Insights automáticos</Typography>

      {insights.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            p: 2,
            borderRadius: 1,
            display: "flex",
            gap: 1.4,
            alignItems: "flex-start",
            bgcolor: item.bg,
            border: "1px solid rgba(11,18,32,0.06)",
            fontSize: 14,
          }}
        >
          {item.icon}
          <Typography>{item.text}</Typography>
        </Box>
      ))}
    </Stack>
  );
}
